// removed by extract-text-webpack-plugin
module.exports = {"title":"_2ZQjwyd6nfUQRGSzQvr1CY","box_input_address":"_1CDV1WaQKCxBMKbCe7yDav"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/Mobile/mobile_choose_address.css
// module id = 3040
// module chunks = 0